var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('camelot-toast',{attrs:{"type":_vm.type,"message":_vm.message},domProps:{"autoClose":_vm.autoClose},on:{"closeToast":_vm.destroy}})
}
var staticRenderFns = []

export { render, staticRenderFns }